/**
 * Session-replay privacy levels — armory's `Enums/Privacy`, kept one-to-one.
 * Each value is the class pair the replay tools read (FullStory `fs-*`,
 * Datadog `dd-privacy-*`); controls emit it on their root element.
 */
export const Privacy = {
  /** Removed from session replay entirely. */
  exclude: 'fs-exclude dd-privacy-hidden',
  /** Masked in session replay. */
  mask: 'fs-mask dd-privacy-mask',
  /** Visible in session replay — the default. */
  unmask: 'fs-unmask dd-privacy-allow',
} as const;

export type Privacy = (typeof Privacy)[keyof typeof Privacy];
